/* global gon */
import React from 'react'
import PropTypes from 'prop-types'

const buildPreviewUrl = (id) => {
  return `${gon.external_turbosquid_draft_preview_url}${id}`
}

const ActionsCell = ({
  id,
}) => (
  <span className='action-icon'>
    <a href={buildPreviewUrl(id)} target="_blank" rel="noopener noreferrer">
      <i className="fa fa-eye" data-toggle="tooltip" title={I18n.t('turbosquid.products.preview_draft')} />
    </a>
  </span>
)

ActionsCell.propTypes = {
  id: PropTypes.string.isRequired,
}

export default ActionsCell
